<template>
  <div class="pa-7" id="function">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
          <div class="">
         <v-card-title class="descriptiontitle">
         <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1"
        large>
        mdi-database-sync-outline
        </v-icon>
              {{ descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ description }}
              </v-card-text>
              </div>
 <div class="">
              <v-card-title class="descriptiontitle">
                       <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1"
        large>
        mdi-account-cog
        </v-icon>{{ descriptiontitle2 }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ description2 }}
              </v-card-text>
          </div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
  color:#345fb5;
  border-bottom:2px solid;
  margin-bottom:0.7rem;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '動作環境',
      // タイトル横のアイコン
      icon: 'mdi-desktop-mac-dashboard',
      // 説明タイトル
      descriptiontitle: 'サーバー',
      // 説明文
      description: `
メモリ: 8GB以上推薦※利用されるユーザー数により異なります。
HDD: 450GB以上推薦※保存するコンテンツの量によって異なります。
OS: CentOS 7.0
データベース: PostgreSQL 9.0
Webアプリケーションサーバー: tomcat9※SSL証明書が必要です。`,
      // 説明タイトル2
      descriptiontitle2: 'クライアント',
      // 説明文2
      description2: `
ブラウザ: Microsoft Edge、InternetExplorer11、Google Chrome、Firefox`
    }
  }
}
</script>
